// client/src/pages/marketing/OverOnsPage.jsx
import React from "react";
import Navbar from "../../components/marketing/Navbar";
import Hero from "../../components/marketing/Hero";
import ContentBlock from "../../components/marketing/ContentBlock";
import Footer from "../../components/marketing/Footer";

const OverOnsPage = () => {
  return (
    <div className="min-h-screen bg-cream-100 text-charcoal-800 font-['Lexend_Deca'] text-base leading-relaxed">
      <Navbar />

      <Hero
        title="Over LerenMotiveren"
        subtitle="Innovatieve online trainingen voor zorgprofessionals"
        height="normal"
      />

      <main className="mx-auto max-w-3xl py-20 px-5">
        <ContentBlock title="Over ons">
          <p>
            LerenMotiveren is opgericht vanuit een eenvoudig idee: met
            AI-technologie kunnen we eindelijk echt interactieve nascholingen
            maken voor zorgprofessionals. Inmiddels hebben we een eerste
            e-learning ontwikkeld en getest met verschillende proefpersonen.
          </p>
          <p className="mt-4">
            Wij verwachten deze in januari 2026 te kunnen laten accrediteren
            voor paramedici.
          </p>
        </ContentBlock>

        <ContentBlock title="Onze missie">
          <p>
            De afgelopen jaren, en zeker sinds de coronaperiode, is het online
            aanbod voor zorgprofessionals sterk gegroeid. Toch zien we dat veel
            scholingen nog leunen op verouderde technologie en een
            onderwijskundige aanpak die weinig ruimte geeft voor echt oefenen.
            Terwijl juist dat oefenen nodig is om nieuwe vaardigheden in de
            praktijk te brengen.
          </p>
          <p className="mt-4">
            Daarom willen wij het anders aanpakken. Ons doel is om
            zorgprofessionals toegang te geven tot kwalitatief goed onderwijs
            dat betaalbaar, praktisch én effectief is. In een sector waar de
            werkdruk hoog is, de administratieve last blijft toenemen en van
            professionals wordt verwacht dat zij zich blijven ontwikkelen, moet
            scholing echt de moeite waard zijn.
          </p>
        </ContentBlock>

        <ContentBlock title="Onze aanpak">
          <p>
            We ontwikkelen e-learnings die wél interactief zijn. Door
            AI-technologie kunnen cursisten oefenen in realistische simulaties
            in plaats van alleen informatie tot zich nemen. In onze eerste
            scholing oefenen cursisten met een virtuele gesprekspartner in
            gesprekstechnieken, waarmee zij specifieke leerdoelen trainen en
            persoonlijke feedback ontvangen.
          </p>
          <p className="mt-4">
            Proefpersonen gaven aan dat deze aanpak hen uitdaagde en bijzonder
            leerzaam was. Omdat je met een virtuele cliënt werkt, kun je rustig
            experimenteren zonder de druk van een live gesprek.
          </p>
        </ContentBlock>

        <ContentBlock title="Het team">
          <p>
            Wij kennen elkaar al sinds onze studietijd Biomedische
            Wetenschappen. Na uiteenlopende loopbanen bundelen we onze ervaring
            met één doel: betere online scholingen voor zorgprofessionals.
          </p>

          <h3 className="mt-6 font-semibold">Roderick</h3>
          <p className="mt-2">
            Roderick is de technische motor achter LerenMotiveren. Hij rondde de
            master <em>Science &amp; Business Management</em> af en werkte
            daarna als senior inspecteur en teamleider bij de IGJ. Vervolgens
            stortte hij zich op AI-technologie en het ondernemerschap. Hij volgt
            de technologische ontwikkelingen op de voet en weet hoe je nieuwe
            technologie praktisch én verantwoord inzet.
          </p>

          <h3 className="mt-6 font-semibold">Simeon</h3>
          <p className="mt-2">
            Simeon heeft een brede onderwijskundige achtergrond. Hij behaalde
            een master in <em>Science Education &amp; Communication</em>
            en deed onderzoek naar het leerrendement van simulatietrainingen.
            Hij stond voor de klas als docent bètavakken en werkte later als
            onderwijsadviseur in de zorgsector, onder andere voor ziekenhuizen
            en het Kwaliteitsregister Paramedici. Daardoor heeft hij scherp
            zicht op wat zorgprofessionals nodig hebben én waar huidige
            scholingen tekortschieten.
          </p>
        </ContentBlock>

        <ContentBlock title="Contact">
          <p>
            Heb je vragen over onze trainingen of wil je meer weten over
            LerenMotiveren? Neem gerust contact met ons op via onze{" "}
            <a
              href="/contact"
              className="text-purple-600 hover:text-purple-800 underline"
            >
              contactpagina
            </a>
            .
          </p>
        </ContentBlock>
      </main>

      <Footer />
    </div>
  );
};

export default OverOnsPage;
